import { render, staticRenderFns } from "./createTemplateModal.vue?vue&type=template&id=b82f8522"
import script from "./createTemplateModal.vue?vue&type=script&lang=ts"
export * from "./createTemplateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports